export const ViewFileIcon = () => {
  return (
    <svg
      id="Component_160_2"
      data-name="Component 160 – 2"
      xmlns="http://www.w3.org/2000/svg"
      width="21.485"
      height="23.966"
      viewBox="0 0 21.485 23.966"
    >
      <path
        id="file"
        d="M8.8,23.03a.936.936,0,0,1-.936.936H3.745A3.749,3.749,0,0,1,0,20.222V3.745A3.749,3.749,0,0,1,3.745,0h11.51A3.749,3.749,0,0,1,19,3.745v8.941a.936.936,0,0,1-1.872,0V3.745a1.875,1.875,0,0,0-1.872-1.872H3.745A1.875,1.875,0,0,0,1.872,3.745V20.222a1.875,1.875,0,0,0,1.872,1.872H7.864A.936.936,0,0,1,8.8,23.03ZM14.318,5.617H4.676a.936.936,0,1,0,0,1.872h9.643a.936.936,0,0,0,0-1.872Zm.936,4.681a.936.936,0,0,0-.936-.936H4.676a.936.936,0,1,0,0,1.872h9.643A.936.936,0,0,0,15.255,10.3ZM4.676,13.107a.936.936,0,1,0,0,1.872H9.6a.936.936,0,1,0,0-1.872Zm16.639,6.857c-.033.047-.146.207-.216.295a13.174,13.174,0,0,1-2.069,2.133,6.42,6.42,0,0,1-4,1.575,6.42,6.42,0,0,1-4-1.575,13.17,13.17,0,0,1-2.069-2.133c-.07-.088-.183-.248-.216-.295a.936.936,0,0,1,0-1.076c.033-.047.146-.207.216-.295a13.171,13.171,0,0,1,2.069-2.132,6.42,6.42,0,0,1,4-1.575,6.42,6.42,0,0,1,4,1.575A13.17,13.17,0,0,1,21.1,18.593c.07.088.183.248.216.295A.936.936,0,0,1,21.315,19.964Zm-1.953-.538c-1.489-1.771-2.946-2.668-4.337-2.668s-2.848.9-4.337,2.668c1.489,1.771,2.946,2.668,4.337,2.668S17.874,21.2,19.362,19.426Zm-4.29-1.779a1.779,1.779,0,1,0,1.779,1.779A1.779,1.779,0,0,0,15.073,17.647Zm0,0"
        fill="#3b4046"
      />
    </svg>
  );
};
